import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../core/language.service';
import { SiteContextService } from 'app/core/site-context.service';

@Component({
  selector: 'app-no-visits',
  templateUrl: './no-visits.component.html',
  styleUrls: ['./no-visits.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoVisitsComponent implements OnInit {
  public datasource = [];

  constructor(
    private readonly languageService: LanguageService,
    private siteContext: SiteContextService,
  ) {}

  public async ngOnInit() {
    this.loadDataForSnippetDialog();
  }

  private async loadDataForSnippetDialog() {
    this.datasource = await this.languageService.translateAsync('dashboard.noVisits.options');
    this.datasource = Object.keys(this.datasource).map((i) => this.datasource[i]);
    this.datasource.forEach((element) => {
      if (element.instructions) {
        const currentSiteId = this.siteContext.getCurrentSiteId();
        element.instructions = element.instructions.replace('{SITE_ID}', currentSiteId);
      }
    });
  }
}
